module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ibox"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "ibox-content"
  }, [_c('ul', {
    directives: [{
      name: "sortable",
      rawName: "v-sortable",
      value: ({
        sorted: this.handlePlannedLoadsSorted
      }),
      expression: "{ sorted: this.handlePlannedLoadsSorted }"
    }],
    staticClass: "list-detail list-detail-planner inline-form-container"
  }, [_vm._l((_vm.plannedLoadsWithoutEmpty), function(load, index) {
    return _c('planned-load', {
      key: load.id,
      attrs: {
        "load": _vm.plannedLoadsWithoutEmpty[index],
        "data-sortable-id": load.id,
        "default-carriers": _vm.carriers
      }
    })
  }), _vm._v(" "), (_vm.noPlannedLoads) ? _c('li', {
    staticClass: "text-center text-muted"
  }, [_vm._v("\n        There are no planned loads.\n      ")]) : _vm._e()], 2)]), _vm._v(" "), _c('div', {
    staticClass: "ibox-footer"
  }, [_c('h4', {
    staticClass: "text-upper"
  }, [_vm._v("Add Load:")]), _vm._v(" "), _c('ul', {
    staticClass: "list-detail list-detail-planner inline-form-container"
  }, [_c('planned-load', {
    attrs: {
      "load": _vm.emptyPlannedLoad,
      "default-carriers": _vm.carriers
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "ibox-footer"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-6 col-md-3 col-lg-3"
  }, [_c('p', {
    staticClass: "load-detail"
  }, [_vm._v("Job Rate: " + _vm._s(_vm.jobDecorated.rate))])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6 col-md-4 col-lg-4"
  }, [_c('p', {
    staticClass: "load-detail"
  }, [_vm._v("\n          Average Rate: " + _vm._s(_vm.averageLoadRateAsMoney) + "\n          "), _c('span', {
    staticClass: "small",
    class: {
      'text-success': _vm.averageIsProfitable, 'text-danger': _vm.averageIsNotProfitable
    }
  }, [_vm._v("\n            (" + _vm._s(_vm.averageProfitPercentage) + "%)\n          ")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-md-5 col-lg-5"
  }, [_c('p', {
    staticClass: "assigned"
  }, [_vm._v("Planned: " + _vm._s(_vm.plannedLoadSize) + " of " + _vm._s(_vm.jobSize) + " tonnes. (" + _vm._s(_vm.plannedLoadPercentage) + "%)")])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ibox-title"
  }, [_c('h2', [_vm._v("Load Planner")])])
}]}


//////////////////
// WEBPACK FOOTER
// ../~/vue-loader/lib/template-compiler?{"id":"data-v-4bdbb3d3"}!../~/vue-loader/lib/selector.js?type=template&index=0!./src/components/jobs/loads/LoadPlanner.vue
// module id = 993
// module chunks = 0